/**
 * Converts a major-unit decimal amount (e.g. a configured line's price) to
 * integer minor units for the elemis boundary (contract §5). The only place
 * in the quote journey that performs this conversion (D5/D12) — callers pass
 * the result straight into `mapMethodToParams`.
 *
 * Pure money util — imports nothing from the transport/axios layer, so it is
 * safe for any quote module (schemas, services, components) to depend on
 * without pulling in `api.ts` or risking a module cycle.
 */
export const toMinorUnits = (majorAmount: number): number => Math.round(majorAmount * 100);
